import api from "@/config/api";
import { auth } from "@/config/firebase";
import useGlobalSpinner from "@/context/spinner";
import { CustomClaims } from "@/types/utils";
import { log } from "@/utils/logger";
import storage from "@/utils/storage";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const useSelect = () => {
    const user = auth.currentUser;
    const navigate = useNavigate();
    const setGlobalLoading = useGlobalSpinner(state => state.setLoading);
    const [selectedOrg, setSelectedOrg] = useState("");

    const onSelect = async (oid: string) => {
        try {
            setGlobalLoading(true);
            setSelectedOrg(oid);
            storage.setItem("oid", oid);

            await api.post("/users/set-claims", { data: { oid } });
            await user?.reload();
            navigate(`/organizations/${oid}/settings`, { replace: true });
        } catch (e) {
            log.error(e, "onSelect");
        } finally {
            setGlobalLoading(false);
        }
    };

    const getClaims = async () => {
        try {
            setGlobalLoading(true);
            const result = await user?.getIdTokenResult();
            const claims = result?.claims as CustomClaims;

            if (claims.organization && claims.organization.oid !== selectedOrg) {
                setSelectedOrg(claims.organization.oid);
            }
        } catch (e) {
            log.error(e, "getClaims");
        } finally {
            setGlobalLoading(false);
        }
    };

    useEffect(() => {
        if (!user) return;
        getClaims();
    }, [user]);

    return {
        onSelect,
        selectedOrg,
        setSelectedOrg,
    };
};

export { useSelect };
